/**
 * Closer EOD Form - Public submission form
 * URL: /closer-eod
 *
 * Renders questions dynamically from the database config.
 */

import { DynamicEodForm } from "./DynamicEodForm";

export function CloserEodForm() {
  return (
    <DynamicEodForm
      formType="closer"
      submitUrl="/api/eod/submit/closer"
      fallbackTitle="Closer EOD Report"
      fallbackSubtitle="Fill out your daily closing report"
    />
  );
}

export default CloserEodForm;
